<!-- Schedule Report Automation popup start here -->
<div class="w-full">
    <p-drawer [(visible)]="scheduleRepotVisible" class="schRepAuto" position="right" [style]="{width: '65vw'}"
        (onHide)="onCancel()">

        <!-- Dynamic Header Template -->
        <ng-template pTemplate="header">
            <div style="width: 94%;">
                <div *ngIf="!isScheduledReport">Report Scheduling</div>
                <div *ngIf="isScheduledReport" class="flex">Scheduled Reports
                    <!-- <ng-container *ngIf="isScheduledReport && savedReports && savedReports.length <= 3"> -->
                    <!-- <button class="ml-auto" type="button" pButton label="Add Schedule"
                            (click)="addNewSchedule()"></button> -->
                    <!-- </ng-container> -->
                </div>
                <div class="repSubT-1 mt-0" *ngIf="!isScheduledReport">(Schedule the reports automatically to deliver the
                    reports to your inbox)</div>
                <div class="repSubT-1 mt-0" *ngIf="isScheduledReport">(View and manage your scheduled reports)</div>
            </div>
        </ng-template>
        <div *ngIf="!isComponentLoading && savedReports && savedReports.length > 0 && isScheduledReport"
            class="flex w-full mb-3"><button class="ml-auto" type="button" pButton label="Add Schedule"
                icon="pi pi-plus" (click)="addNewSchedule()"></button></div>
        <div *ngIf="isScheduledReport">
            <div class="schRepList" *ngFor="let report of savedReports; let i = index">
                <div class="schRAct">
                    <a class="cursor-pointer"><i class="pi pi-pencil" (click)="editSchedule(report)" tooltip="Edit"
                            tooltipPosition="top"></i></a>
                    <a class="cursor-pointer"><i class="pi pi-trash" (click)="deleteSchedule(report)" tooltip="Delete"
                            tooltipPosition="top"></i></a>
                </div>
                <div class="flex">
                    <div class="mr-2"><img src="assets/images/pie-chart-outline.svg" alt="" /></div>
                    <div class="schRT-1">{{ report.reportName || 'Untitled Report' }}</div>
                </div>
                <div class="schRT-2 mt-3">
                    <div class="flex mb-2"><span class="font-bold">Frequency
                        </span>&nbsp; : <span *ngIf="report.cronFrequencyType === 1" class="color-orange ml-1 mr-1">
                            Daily
                        </span>
                        <span *ngIf="report.cronFrequencyType === 1">{{report.cronFrequencySelectedTime || '00:00'
                            }} EST </span>
                        <span *ngIf="report.cronFrequencyType === 2" class="color-orange ml-1 mr-1"> Weekly</span>
                        <span *ngIf="report.cronFrequencyType === 2">({{getWeekDayName(report.cronFrequencyWeek)}})
                            &nbsp; {{report.cronFrequencySelectedTime || '00:00' }} EST; </span>
                        <span *ngIf="report.cronFrequencyType === 3" class="color-orange ml-1 mr-1"> Monthly </span>
                        <span *ngIf="report.cronFrequencyType === 3">(Every {{getDayOfMonth(report.cronFrequencyDate ||
                            1)}})
                            &nbsp; {{report.cronFrequencySelectedTime || '00:00' }} EST </span>
                    </div>
                    <div class="flex mb-2">
                        <span class="font-bold">Recipients</span> &nbsp; : &nbsp;
                        <div>
                            <span>{{ isRecipientsExpanded(report.id || 0) ? getRecipientNames(report.alertTo) :
                                (getRecipientNames(report.alertTo) | slice:0:100) +
                                (getRecipientNames(report.alertTo).length > 100 ? '...' : '') }}</span>
                            <a class="cursor-pointer primary" *ngIf="getRecipientNames(report.alertTo).length > 100"
                                (click)="toggleRecipients(report.id || 0)" class="cursor-pointer primary ml-2">
                                {{ isRecipientsExpanded(report.id || 0) ? 'View Less' : 'View More' }}
                            </a>
                        </div>
                    </div>
                    <div class="flex mb-2">
                        <span class="font-bold">Subject</span>&nbsp; : &nbsp;
                        <div>
                            <span>{{ report.subject }}</span>
                        </div>
                    </div>
                </div>
                <div class="schRT-3 mt-2">
                    <div class="flex mb-0 font-bold">Email Body</div>
                    <div>
                        <span>{{ isEmailBodyExpanded(report.id || 0) ? stripHtmlTags(report.bodyDesc) :
                            (stripHtmlTags(report.bodyDesc) | slice:0:100) + ((stripHtmlTags(report.bodyDesc).length ||
                            0) >= 100 ? '...' : '') }}</span>
                        <a class="cursor-pointer primary" *ngIf="(stripHtmlTags(report.bodyDesc).length || 0) >= 100"
                            (click)="toggleEmailBody(report.id || 0)" class="cursor-pointer primary ml-2">
                            {{ isEmailBodyExpanded(report.id || 0) ? 'View Less' : 'View More' }}
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Main Content -->
        <ng-container *ngIf="!isScheduledReport; else savedReportsList">
            <!-- Show loading state for entire component -->
            <div *ngIf="isComponentLoading" class="text-center p-4">
                <i class="pi pi-spin pi-spinner text-4xl text-gray-400 mb-3"></i>
                <p class="text-gray-600">Loading schedule form...</p>
            </div>

            <!-- Create Reports List Start Here -->
            <form *ngIf="!isComponentLoading" [formGroup]="scheduleForm" (ngSubmit)="onSubmit()">
                <input type="hidden" formControlName="id" />
                <input type="hidden" formControlName="savedReportId" />
                <div class="sectWB">
                    <div class="flex">
                        <div class="sectLab mb-3 mr-4">Frequency & Time</div>
                        <div class="inline-flex">
                            <div class="flex items-center mr-3">
                                <p-radiobutton formControlName="cronFrequencyType" value="1" name="cronFrequencyType"
                                    [class.active]="selectedFrequency === '1'" (click)="selectFrequency('1')" />
                                <label for="Daily" class="ml-2">Daily</label>
                            </div>

                            <div class="flex items-center mr-3">
                                <p-radiobutton formControlName="cronFrequencyType" value="2" name="cronFrequencyType"
                                    [class.active]="selectedFrequency === '2'" (click)="selectFrequency('2')" />
                                <label for="Weekly" class="ml-2">Weekly</label>
                            </div>

                            <div class="flex items-center mr-3">
                                <p-radiobutton formControlName="cronFrequencyType" value="3" name="cronFrequencyType"
                                    [class.active]="selectedFrequency === '3'" (click)="selectFrequency('3')" />
                                <label for="Monthly" class="ml-2">Monthly</label>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="flex mb-4">
                        <div class="fqBx mr-2 cursor-pointer" [class.active]="selectedFrequency === '1'"
                            (click)="selectFrequency('1')">Daily</div>
                        <div class="fqBx mr-2 cursor-pointer" [class.active]="selectedFrequency === '2'"
                            (click)="selectFrequency('2')">Weekly</div>
                        <div class="fqBx cursor-pointer" [class.active]="selectedFrequency === '3'"
                            (click)="selectFrequency('3')">Monthly</div>
                    </div> -->

                    <div class="grid m-0 align-items-baseline">
                        <ng-container *ngIf="selectedFrequency === '2'">
                            <div class="field inptLP mb-2 width200">
                                <label>Select Day of the Week</label>
                                <p-select [options]="weekDays" optionLabel="name" optionValue="code"
                                    formControlName="cronFrequencyWeek" placeholder="Day" [filter]="true"
                                    class="w-full" />
                                <small class="p-error"
                                    [style.opacity]="(scheduleForm.get('cronFrequencyWeek')?.invalid && scheduleForm.get('cronFrequencyWeek')?.touched) ? '1' : '0'">
                                    Day is required for weekly schedule
                                </small>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="selectedFrequency === '3'">
                            <div class="field  inptLP mb-2 width200">
                                <label>Select Date of the Month</label>
                                <p-select [options]="daysOfMonth" optionLabel="name" optionValue="code"
                                    formControlName="cronFrequencyDate" placeholder="Select Date" [filter]="true"
                                    class="w-full" />
                                <small class="p-error"
                                    [style.opacity]="(scheduleForm.get('cronFrequencyDate')?.invalid && scheduleForm.get('cronFrequencyDate')?.touched) ? '1' : '0'">
                                    Date is required for monthly schedule
                                </small>
                            </div>
                        </ng-container>

                        <div class="field  inptLP mb-2 width200">
                            <label>Select Hour per day </label>
                            <p-select [options]="hours" optionLabel="name" optionValue="code"
                                formControlName="CronFrequencyHrs" placeholder="Hour" [filter]="true" class="w-full" />
                            <small class="p-error"
                                [style.opacity]="(scheduleForm.get('CronFrequencyHrs')?.invalid && scheduleForm.get('CronFrequencyHrs')?.touched) ? '1' : '0'">
                                Hour is required
                            </small>
                        </div>
                        <div class="field  pl-0 inptLP mb-2 width200">
                            <label>Select Minutes</label>
                            <p-select [options]="minutes" optionLabel="name" optionValue="code"
                                formControlName="CronFrequencySlot" placeholder="Minutes" [filter]="true"
                                class="w-full" />
                            <small class="p-error"
                                [style.opacity]="(scheduleForm.get('CronFrequencySlot')?.invalid && scheduleForm.get('CronFrequencySlot')?.touched) ? '1' : '0'">
                                Minutes field is required
                            </small>
                        </div>
                        <div class="field  pl-0 inptLP mb-2">
                            <label>&nbsp;</label>
                            <div class="flex pt-2 ">EST</div>

                        </div>

                        <div class="col-12 pt-0 inptLP">
                            <a class="BlTxt cursor-pointer" (click)="openTimezoneModal()">Check Time Zone <i
                                    [class]="timeZoneArrowClass"></i></a>
                            <div class="timezoneInfo">(Report times are in EST by default.Select your timezone from the
                                dropdown to see the local time before Scheduling)</div>
                        </div>
                        <div class="timezoneB" *ngIf="timezoneBlock">
                            <ng-container >
                                <div class="label w-full inptLP">
                                    <label class="mb-2 font-semdibold">Check Time Zone</label>
                                </div>
                                <div class="w-full timezoneForm">
                                    <div class="field  inptLP width200">
                                        <label>Select Hours</label>
                                        <p-select [options]="hours" optionLabel="name" optionValue="code"
                                            formControlName="checkCronFrequencyHrs" placeholder="Hour" [filter]="true"
                                            class="w-full" (onChange)="getConvertedTimezone()" />
                                    </div>
                                    <div class="field pl-0 inptLP width200">
                                        <label>Select Minutes</label>
                                        <p-select [options]="minutes" optionLabel="name" optionValue="code"
                                            formControlName="checkCronFrequencySlot" placeholder="Minute"
                                            [filter]="true" class="w-full" (onChange)="getConvertedTimezone()" />
                                    </div>

                                    <div class="field  inptLP" style="width: 34%;">
                                        <label>Select Time Zone</label>
                                        <p-select [options]="timeZones" optionLabel="name" optionValue="code"
                                            formControlName="checkTimezone" placeholder="Time Zone" [filter]="true"
                                            class="w-full" (onChange)="getConvertedTimezone()" />
                                    </div>

                                    <div class="field  pl-0 inptLP width200">
                                        <label>Equals to</label>
                                        <input type="text" readonly pInputText class="w-full"
                                            formControlName="checkIsttime" />
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <div class="sectWB">
                    <div class="sectLab mb-3">Alert Configuration</div>
                    <div class="grid">
                        <div class="field col-5 inptLP">
                            <label>Choose the recipients to notify</label>
                            <p-multiselect [options]="notifyList" formControlName="alertTo"
                                placeholder="Select Notifiers" optionLabel="name" optionValue="code" display="chip"
                                [filter]="true" class="w-full" />

                            <small class="p-error"
                                [style.opacity]="(scheduleForm.get('alertTo')?.invalid && scheduleForm.get('alertTo')?.touched) ? '1' : '0'">
                                Recipients is required
                            </small>
                            <div class="subTxt mt-0">(System sends the report notification to these recipients in the
                                scheduled time)</div>
                        </div>
                        <div class="field col-5 inptLP pl-0">
                            <label>Select Period</label>
                            <p-select [options]="periodList" formControlName="automationPeriodValue" optionLabel="name"
                                optionValue="code" placeholder="Select Period" [filter]="true" class="w-full" />
                            <small class="p-error"
                                [style.opacity]="(scheduleForm.get('automationPeriodValue')?.invalid && scheduleForm.get('automationPeriodValue')?.touched) ? '1' : '0'">
                                Period is required
                            </small>
                        </div>
                    </div>
                </div>

                <div class="sectWB">
                    <div class="sectLab mb-3">Email Configuration</div>
                    <div>
                        <div class="field mb-0">
                            <label>Merge fields to configure the Email Subject and Body</label>
                        </div>
                        <div class="grid align-items-center">
                            <div class="field col inptLP pr-3">
                                <p-select [options]="moduleList" formControlName="tableNameApplicant" optionLabel="name"
                                    optionValue="code" [placeholder]="'Select User Details'" (onChange)="onModuleChange($event)"
                                    [filter]="true" class="w-full" />
                            </div>
                            <div class="field col inptLP pl-0 pr-3">
                                <p-select [options]="columns" formControlName="tableColumnName" optionLabel="name"
                                    optionValue="code" placeholder="Select Option" [filter]="true" class="w-full" />
                            </div>
                            <div class="field col inptLP pl-0 pr-3">
                                <p-select [options]="actionList" formControlName="mergeField3" optionLabel="name"
                                    optionValue="code" placeholder="Select Option" [filter]="true" class="w-full" />
                            </div>
                            <div class="field inptLP pl-0 pr-3">
                                <button type="button" pButton label="Add" icon="pi pi-plus" style="height: 36px;"
                                    (click)="addMergeField()"></button>
                            </div>
                        </div>
                    </div>
                    <div class="grid">
                        <div class="field col-12">
                            <label>Subject</label>
                            <input type="text" pInputText class="w-full" formControlName="subject" />
                        </div>
                    </div>
                </div>
                <div class="grid">
                    <div class="field col-12">
                        <label>Email Body</label>
                        <p-editor #editor formControlName="bodyDesc" [style]="{ height: '250px' }" />
                        <small class="p-error"
                            [style.opacity]="(scheduleForm.get('bodyDesc')?.invalid && scheduleForm.get('bodyDesc')?.touched) ? '1' : '0'">
                            Email Body is required
                        </small>
                    </div>
                </div>
            </form>
        </ng-container>

        <!-- Saved Reports List -->
        <ng-template #savedReportsList>
            <!-- Saved Reports List Content -->

        </ng-template>

        <!-- Dynamic Footer Template -->
        <ng-template pTemplate="footer">
            <div class="flex items-center gap-2" *ngIf="!isComponentLoading">
                <!-- Footer for Create/Edit Schedule -->
                <ng-container *ngIf="!isScheduledReport">
                    <button type="submit" pButton label="Save Schedule" (click)="onSubmit()"></button>
                    <button type="button" pButton label="Cancel" (click)="onCancel()" [outlined]="true"
                        severity="secondary"></button>
                </ng-container>
            </div>
        </ng-template>

    </p-drawer>

    <!-- PrimeNG Confirmation Dialog -->
    <p-confirmDialog></p-confirmDialog>
</div>
<!-- Schedule Report Automation popup end here -->